var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredByDigimarc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255 72",
    style: {
      enableBackground: "new 0 0 255 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.4,
    y: 42.8,
    className: "st0",
    width: 4.9,
    height: 20.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 42.8,
    className: "st0",
    width: 4.9,
    height: 20.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "114.9,42.8 118.9,42.8 128.8,54.8 138.6,42.8 142.6,42.8 142.6,63.1 138,63.1 138,49.1 129,60.6  128,60.6 118.9,49.5 118.9,63.1 114.9,63.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.8,54.9l4.5-8.4l4.7,8.4h-9.3H160.8z M151.2,63.1h4.9l2.5-4.5H172l2.5,4.5h5.6l-12.2-20.3h-4.7 L151.2,63.1L151.2,63.1L151.2,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.3,46.3c1.5,0,2.3,0.3,2.3,1.6v2.3c0,1.3-0.8,1.6-2.3,1.6H193v-5.6L204.3,46.3L204.3,46.3z M188.1,63.1 h4.9v-7.7h4.6l8.5,7.7h7.1l-9.6-7.7h2.8c3.3,0,4.7-1.1,4.7-3.9v-4.8c0-2.8-1.5-3.9-4.7-3.9h-18.3V63.1L188.1,63.1L188.1,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,59.4V46.6h8.7c4.7,0,7,2,7,6.2s-3.1,6.7-9.4,6.7H18L18.1,59.4L18.1,59.4z M13.1,63.2h12.4 c8.9,0,13.4-3.4,13.4-10.2s-4.2-10.1-12.2-10.1H13L13.1,63.2L13.1,63.2L13.1,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.5,59.6h-8.7c-4.7,0-7.1-2-7.1-6.2s3.1-6.7,9.4-6.7H87v-3.8H75c-8.9,0-13.4,3.4-13.4,10.2 s4.2,10.1,12.2,10.1H87V51.9h-9.9v4h5.5L82.5,59.6L82.5,59.6L82.5,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.9,59.4h-11.3c-4.7,0-7-2-7-6.2s3.1-6.7,9.4-6.7h8.9v-3.8h-10c-8.9,0-13.4,3.4-13.4,10.2 S223.7,63,231.7,63h11.2L242.9,59.4L242.9,59.4L242.9,59.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.4,21.3V8h5.9c2.8,0,4.3,1.9,4.3,4.2s-1.6,4.2-4.3,4.2h-3.5v5L76.4,21.3L76.4,21.3z M84.2,12.2c0-1.3-0.9-2.1-2.3-2.1 h-3.2v4.2h3.2C83.2,14.3,84.2,13.5,84.2,12.2L84.2,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6,16.5c0-2.8,1.9-5.1,5-5.1s5,2.3,5,5.1s-1.9,5.1-5,5.1S87.6,19.3,87.6,16.5z M95.3,16.5c0-1.7-1-3.2-2.8-3.2 s-2.8,1.5-2.8,3.2s1,3.2,2.8,3.2S95.3,18.2,95.3,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,21.3l-2.3-7.1l-2.2,7.1h-2.2l-3-9.7h2.2l2,7l2.3-7h1.9l2.3,7l2-7h2.2l-3,9.7H108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,16.5c0-2.8,2-5.1,4.9-5.1s4.7,2.2,4.7,5.2v0.5h-7.4c0.2,1.4,1.2,2.7,3.1,2.7s2.1-0.4,2.8-1.1l1,1.4 c-1,0.9-2.4,1.4-3.9,1.4c-2.9,0-5.1-2-5.1-5.1L114.2,16.5z M119.1,13.2c-1.8,0-2.6,1.4-2.7,2.5h5.4C121.8,14.6,121,13.2,119.1,13.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,21.3v-9.7h2.1V13c0.7-0.9,1.9-1.6,3.1-1.6v2.1c-0.2,0-0.4,0-0.6,0c-0.9,0-2.1,0.6-2.5,1.3v6.6h-2.1V21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2,16.5c0-2.8,2-5.1,4.9-5.1s4.7,2.2,4.7,5.2v0.5h-7.4c0.2,1.4,1.2,2.7,3.1,2.7s2.1-0.4,2.8-1.1l1,1.4 c-1,0.9-2.4,1.4-3.9,1.4c-2.9,0-5.1-2-5.1-5.1L132.2,16.5z M137.1,13.2c-1.8,0-2.6,1.4-2.7,2.5h5.4C139.8,14.6,139,13.2,137.1,13.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,21.3V20c-0.7,1-1.8,1.6-3.1,1.6c-2.5,0-4.3-1.9-4.3-5.1s1.8-5.1,4.3-5.1s2.3,0.5,3.1,1.6V8h2.1v13.3H150.8z  M150.8,18.4v-3.8c-0.5-0.7-1.5-1.3-2.5-1.3c-1.7,0-2.7,1.3-2.7,3.2s1.1,3.2,2.7,3.2S150.3,19.1,150.8,18.4L150.8,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,21.3V8h2.1v5c0.8-1,1.9-1.6,3.1-1.6c2.5,0,4.3,1.9,4.3,5.1s-1.8,5.1-4.3,5.1s-2.4-0.6-3.1-1.6v1.3H160.8z  M165.4,19.7c1.7,0,2.7-1.3,2.7-3.2s-1.1-3.2-2.7-3.2s-2,0.6-2.5,1.3v3.8C163.4,19.1,164.4,19.7,165.4,19.7L165.4,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,23.2c0.2,0.1,0.6,0.2,0.8,0.2c0.7,0,1.1-0.2,1.4-0.8l0.5-1.1l-4-9.8h2.3l2.8,7.2l2.8-7.2h2.2l-4.7,11.4 c-0.7,1.6-1.8,2.2-3.3,2.2c-0.3,0-0.9,0-1.2-0.1l0.3-1.9L172.3,23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByDigimarc);
export default __webpack_public_path__ + "static/media/powered-by-digimarc.07b4df0e569e7e5a59db11040743b54c.svg";
export { ForwardRef as ReactComponent };